module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.type === 'select') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempValue),
      expression: "tempValue"
    }],
    ref: "input",
    staticClass: "input",
    attrs: {
      "id": _vm.id
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.handleInput($event.target.value)
      }],
      "blur": _vm.handleBlur
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option[_vm.option_value],
        "textContent": _vm._s(option[_vm.option_name])
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type === 'states') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempValue),
      expression: "tempValue"
    }],
    ref: "input",
    staticClass: "input",
    attrs: {
      "id": _vm.id
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tempValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.handleInput($event.target.value)
      }],
      "blur": _vm.handleBlur
    }
  }, [_c('option', {
    domProps: {
      "textContent": _vm._s(_vm.placeholder)
    }
  }), _vm._v(" "), _vm._l((_vm.states), function(state, index) {
    return _c('option', {
      domProps: {
        "value": index,
        "textContent": _vm._s(state)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.type === 'timezone') ? _c('timezone-picker', {
    ref: "input",
    attrs: {
      "id": _vm.id,
      "value": _vm.tempValue
    },
    on: {
      "input": function($event) {
        return _vm.handleInput($event)
      },
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempValue),
      expression: "tempValue"
    }],
    ref: "input",
    staticClass: "textarea",
    attrs: {
      "id": _vm.id,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.tempValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tempValue = $event.target.value
      }, function($event) {
        return _vm.handleInput($event.target.value)
      }],
      "keydown": function($event) {
        return _vm.handleKeyDown($event)
      },
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'checkbox') ? _c('label', {
    staticClass: "checkbox",
    attrs: {
      "for": _vm.id
    }
  }, [_c('input', {
    ref: "input",
    staticClass: "checkbox",
    attrs: {
      "id": _vm.id,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.tempValue,
      "checked": _vm.value === true
    },
    on: {
      "change": _vm.handleCheckbox,
      "blur": _vm.handleBlur
    }
  }), _vm._v(" "), _vm._t("label")], 2) : _vm._e(), _vm._v(" "), (_vm.type === 'file') ? _c('input', {
    ref: "input",
    staticClass: "input",
    attrs: {
      "id": _vm.id,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.tempValue,
      "checked": _vm.value === true
    },
    on: {
      "change": _vm.handleCheckbox,
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type !== 'select' &&
    _vm.type !== 'timezone' &&
    _vm.type !== 'states' &&
    _vm.type !== 'textarea' &&
    _vm.type !== 'radio' &&
    _vm.type !== 'file' &&
    _vm.type !== 'checkbox') ? _c('input', {
    ref: "input",
    staticClass: "input",
    attrs: {
      "id": _vm.id,
      "type": _vm.type,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.tempValue
    },
    on: {
      "input": function($event) {
        return _vm.handleInput($event.target.value)
      },
      "keydown": function($event) {
        return _vm.handleKeyDown($event)
      },
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-441a7e06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/FormControl.vue
// module id = 530
// module chunks = 0